<template>
  <div :class="this.searchActive? 'dropdown active': 'dropdown'">
    <div class="dropdown__container">
      <div class="dropdown__search">

        <label class="dropdown__label" for="search"></label>
        <input
          class="dropdown__input"
          id="search"
          name="search"
          placeholder="Szukaj w serwisie..."
          v-model="searchQuery"
          @input='search'
          autocomplete="off"
          type="text"
        />

        <div class="dropdown__search-icon" v-on:click="search" />
      </div>
      <div class="checkboxes">
        <div class="checkbox">
        <input
          class="checkboxes__input"
          id="notes"
          name="notes"
          type="checkbox"
          value="Notowanie"
          v-model="toplist"
          @change="toplistChange"
        />
        <label class="checkboxes__label" for="notes">Notowanie</label>
</div>
        <div class="checkbox">
          <input
            class="checkboxes__input"
            id="year"
            name="year"
            type="checkbox"
            value="Rok notowania"
            v-model="data"
            @change="dataChange"
          />
          <label
            class="checkboxes__label"
            for="year"
            tabindex="0"
            aria-label="Rok notowania"
          >
            Rok
          </label>
        </div>
        <div class="checkbox">

        <input
          class="checkboxes__input"
          id="artist"
          name="artist"
          type="checkbox"
          value="Artysta"
          v-model="artist"
          @change="artistChange"
        />
        <label class="checkboxes__label" for="artist">Artysta</label>
        </div>
                <div class="checkbox">

        <input
          class="checkboxes__input"
          id="song"
          name="song"
          type="checkbox"
          value="Utwór"
           v-model="song"
          @change="songChange"
        />
        <label class="checkboxes__label" for="song">Piosenka</label>
                </div>

      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';
export default {
  mixins: [mixin]
};
</script>

<style scoped lang="scss">

  .dropdown {
  height: 8rem;
  background-color: #242838;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s linear;
  &.active {
    max-height: 8rem;
  }
  &__container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center
  }
  &__search {
    position: relative;
    width: 100%;
    height: 60%;
    display: flex;
  }
  &__icons {
    height: 100%;
    display: flex;
    align-items: center;
  }
  &__search-icon {
    width: 2.1rem;
    height: 2.1rem;
    background-image: url("/icons/search.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
    position: absolute;
    right: 1.5rem;
    top: 1.3rem;
  }
  &__label {
    visibility: hidden;
  }
  &__input {
    background-color: #2b3349;
    height: 100%;
    border: none;
    width: 100%;
    box-sizing: border-box;
    color: #536186;
    font-size: 20px;
    font-family: "Poppins", sans-serif;
    padding-left: 25%;
  }

  .checkboxes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 95%;
    &__input {
      margin-left: 1.5rem;
      margin-right: 0.75rem;
      width: 1.3em;
      height: 1.3em;
      background-color: #b3bdda;
      border-radius: 50%;
      vertical-align: middle;
      border: 1px solid #ddd;
      -webkit-appearance: none;
      outline: none;
      cursor: pointer;
      position: relative;
      &:checked::after {
        content: "";
        width: 60%;
        height: 60%;
        background-color: #2a2838;
        top: 20%;
        left: 20%;
        border-radius: 50%;
        position: absolute;
      }
    }
    &__label {
      color: #b1bbd7;
      font-family: "Poppins", sans-serif;
    }
  }
  .checkbox {
    display: flex;
    align-items: center;
  }
}
</style>
